<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken, removeToken } from "@/utils/auth";
export default {
  name: "App",
  beforeCreate() {
    // 这里应该要处理一下
    if (!getToken()) {
      // 无 token，跳登录或不做事
      removeToken();
      //  清除权限
      localStorage.removeItem("user_permissions");
      if (this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    }
  },
  created() {
     // 设置网页标题
    document.title = "池上乐乐";
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
  width: 100%;
}
.el-form-item__label {
  text-align: center !important;
}
</style>
